// opervex-frontend/src/utils/OpervexStorage.js
const OpervexStorage = (() => {
  const regexUUID = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

  /**
   * ============================
   * TENANT
   * ============================
   */

  const getTenantIdFromPath = () => {
    const parts = window.location.pathname.split("/");
    return regexUUID.test(parts[1]) ? parts[1] : null;
  };

  const getTenantId = () => {
    return localStorage.getItem("current_tenant_id");
  };

  const setTenantId = (tenantId) => {
    if (!tenantId) return;
    localStorage.setItem("current_tenant_id", tenantId);
  };

  const getActiveTenantId = () => {
    return getTenantId() || getTenantIdFromPath();
  };

  const makeKey = (suffix) => {
    const tenantId = getActiveTenantId();
    return tenantId ? `${tenantId}_${suffix}` : null;
  };

  /**
   * ============================
   * USER
   * ============================
   */

  const getUser = () => {
    const key = makeKey("user");
    if (!key) return null;
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  };

  const setUser = (user) => {
    const key = makeKey("user");
    if (key) localStorage.setItem(key, JSON.stringify(user));
  };

  /**
   * ============================
   * ROLES
   * ============================
   */

  const getRoles = () => {
    const key = makeKey("roles");
    if (!key) return null;
    const raw = localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  };

  /**
   * ============================
   * EXPIRATION
   * ============================
   */

  const getExpiration = () => {
    const key = makeKey("expiration");
    return key ? localStorage.getItem(key) : null;
  };

  const isExpired = () => {
    const exp = getExpiration();
    return exp && new Date().getTime() > new Date(exp).getTime();
  };

  const setRoles = (tenantId, roles) => {
    if (!tenantId) return;
    localStorage.setItem(`${tenantId}_roles`, JSON.stringify(roles));
  };

  /**
   * ============================
   * SET ALL (LOGIN)
   * ============================
   */
  const setAll = ({ tenantId, user, roles, expiration }) => {
    if (!tenantId) return;

    setTenantId(tenantId);

    localStorage.setItem(`${tenantId}_user`, JSON.stringify(user));
    localStorage.setItem(`${tenantId}_roles`, JSON.stringify(roles));
    localStorage.setItem(`${tenantId}_expiration`, expiration);
  };

  /**
   * ============================
   * CLEAR (LOGOUT / TENANT CHANGE)
   * ============================
   */

  const clear = () => {
    const tenantId = getActiveTenantId();
    if (!tenantId) return;

    localStorage.removeItem(`${tenantId}_user`);
    localStorage.removeItem(`${tenantId}_roles`);
    localStorage.removeItem(`${tenantId}_expiration`);
    localStorage.removeItem("current_tenant_id");
  };

  /**
   * ============================
   * TENANT CHANGE GUARD
   * ============================
   */

  const checkTenantChange = () => {
    const pathTenant = getTenantIdFromPath();
    const storedTenant = getTenantId();

    if (storedTenant && pathTenant && storedTenant !== pathTenant) {
      clear();
    }
  };

  return {
    // tenant
    getTenantIdFromPath,
    getTenantId,
    setTenantId,
    getActiveTenantId,

    // auth data
    getUser,
    setUser,
    getRoles,
    setRoles,
    getExpiration,
    isExpired,

    // helpers
    setAll,
    clear,
    checkTenantChange,
  };
})();

export default OpervexStorage;
